
/* *
 *
 * @author whiteshader@163.com
 * @datetime  2021/09/16
 * 
 * */

export default {
  'monitor.server.cpu.cpuNum': '核心数',
  'monitor.server.cpu.total': '总使用率',
  'monitor.server.cpu.sys': '系统使用率',
  'monitor.server.cpu.used': '用户使用率',
  'monitor.server.cpu.wait': 'IO等待',
  'monitor.server.cpu.free': '当前空闲率',
  'monitor.server.mem.total': '总内存',
  'monitor.server.mem.used': '已用内存',
  'monitor.server.mem.free': '剩余内存',
  'monitor.server.mem.usage': '使用率',
  'monitor.server.disk.dirName': '盘符路径',
  'monitor.server.disk.sysTypeName': '文件系统',
  'monitor.server.disk.typeName': '盘符类型',
  'monitor.server.disk.total': '总大小',
  'monitor.server.disk.free': '可用大小',
  'monitor.server.disk.used': '已用大小',
  'monitor.server.disk.usage': '使用率',
};
